
function listenMenuMobile() {
  const menuMobile = document.querySelector('.mobile-toggle');
  menuMobile.addEventListener("click", function(){
    const appChat = document.querySelector('#ShopifyChat');
    const appWhatsapp = document.querySelector('.satellite-bubble');
    appChat.classList.toggle('noIndex');
    appWhatsapp.classList.toggle('noIndex');
  })
}

function calcMenuH(){
  const menu = document.querySelector("#header");
  if(menu != null){
      menuh = menu.offsetHeight;
  }
  else{
      menuh = 0;
  }
  menuh += `px`;
  return menuh;
}


function addToWishlist(productId, productSrc, productPrice, productTitle, productUrl, productVariantId) {
  const product = {
    id: productId,
    src: productSrc,
    price: productPrice,
    title: productTitle,
    url: productUrl,
    variantId: productVariantId
  };

  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  if (!wishlist.some(item => item.id === productId)) {
    wishlist.push(product);

    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    updateCurrentHeart(productId);
    openPanel();
    updateWishlistUI();
  } else {
    updateCurrentHeart(productId, true);
    removeFromWishlist(productId);
    openPanel();
    updateWishlistUI();
  }
}

function updateWishlistUI() {
  const wishlistContainer = document.getElementById('wishlist-custom');
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  wishlistContainer.innerHTML = '';

  wishlist.forEach(product => {
    const listItem = document.createElement('div');
    listItem.className = 'wishlist-card d-flex mb-3';
    listItem.innerHTML = `
      <a href="${product.url}">
        <img width="100" height="50" src="${product.src}" class="wishlist-image" />
      </a>
      <div class="wishlist-details ml-2 d-flex flex-column">
        <span class="wishlist-title extraSmallParagraphMedium mb-2">${product.title}</span>
        <span class="wishlist-price extraSmallParagraph">${product.price}</span>
        <div class="wishlist-buttons d-flex mt-auto">
          <div class="addToCartWishlist">
            <form id="addToCartForm_${product.id}" method="post" action="/cart/add">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="id" value="${product.variantId}">
              <input type="hidden" name="quantity" value="1">
              <i class="fas fa-shopping-bag cursor-pointer mr-2" onclick="document.getElementById('addToCartForm_${product.id}').submit();"></i>
            </form>
          </div>
          <div class="addToTrashWishlist">
            <i class="fas fa-trash cursor-pointer" onclick="removeFromWishlist(${product.id})"></i>
          </div>
        </div>
      </div>
    `;
    wishlistContainer.appendChild(listItem);
  });
}

function removeFromWishlist(productId) {
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  wishlist = wishlist.filter(item => item.id != productId);

  localStorage.setItem('wishlist', JSON.stringify(wishlist));

  updateCurrentHeart(productId, true);

  updateWishlistUI();
}

function updateCurrentHeart(dataProduct , isDelete = false) {
  const currentDataProduct = document.querySelector(`.product-card .custom-heart[data-product='${dataProduct}'] svg`);
  
  if (currentDataProduct) {
    if(isDelete){
      currentDataProduct.style.fill = '';
    } else{
      currentDataProduct.style.fill = '#C99F91';
    }
  }
}

function updateAllHeart() {
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  wishlist.forEach((item) => {
    const currentDataProduct = document.querySelector(`.product-card .custom-heart[data-product='${item.id}'] svg`);
    if (currentDataProduct) {
      currentDataProduct.style.fill = '#C99F91';
    } else {
      // console.error('Elemento non trovato');
    }
  });
}

function openPanel(){
  const panel = document.querySelector('#Cart-Drawer');
  panel.classList.add('active');
  const tabWishlist = document.querySelector('#nav-wishlist-tab');
  tabWishlist.click();
}

window.onload = function() {
  updateWishlistUI();
  updateAllHeart();
};